import { CommonModule } from '@angular/common';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { timer } from 'rxjs';
import { AuthService } from '../../services/auth';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, RouterLink, NgxMaskDirective],
  templateUrl: './register.html',
  styleUrls: ['./register.scss'],
  providers: [provideNgxMask()],
})
export class RegisterComponent {
  step: number = 1;
  registerForm: FormGroup;
  confirmPasswordForm: FormGroup;
  registrationSuccess = false;
  registrationError = false;
  errorMessage = '';
  isSubmitting = false;

  // Getters para facilitar a validação no template
  get passwordsMatch(): boolean {
    const password = this.registerForm.get('password')?.value || '';
    const confirmPassword =
      this.confirmPasswordForm.get('confirmPassword')?.value || '';
    return password === confirmPassword;
  }

  get isStep1Valid(): boolean {
    return (
      !!this.registerForm.get('name')?.valid &&
      !!this.registerForm.get('email')?.valid &&
      !!this.registerForm.get('password')?.valid &&
      !!this.registerForm.get('cnpj')?.valid &&
      this.passwordsMatch
    );
  }

  get isStep2Valid(): boolean {
    return (
      !!this.registerForm.get('phone')?.valid &&
      !!this.registerForm.get('postal_code')?.valid &&
      !!this.registerForm.get('address_number')?.valid
    );
  }

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router
  ) {
    this.registerForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      cnpj: ['', Validators.required],
      phone: ['', Validators.required],
      postal_code: ['', Validators.required],
      address_number: ['', Validators.required],
      complement: [''], // Opcional, sem validador required
    });

    this.confirmPasswordForm = this.fb.group({
      confirmPassword: ['', Validators.required],
    });
  }

  nextStep(): void {
    if (this.step === 1 && this.isStep1Valid) {
      this.step = 2;
    }
  }

  previousStep(): void {
    if (this.step === 2) {
      this.step = 1;
    }
  }

  onSubmit(): void {
    if (this.registerForm.valid && this.isStep2Valid) {
      this.isSubmitting = true;
      this.authService.register(this.registerForm.value).subscribe({
        next: () => {
          this.registrationSuccess = true;
          this.registrationError = false;
          this.isSubmitting = false;

          // Redirecionar para login após 3 segundos
          timer(3000).subscribe(() => {
            this.router.navigate(['/login']);
          });
        },
        error: (err) => {
          console.error('Registration failed', err);
          this.isSubmitting = false;
          this.registrationError = true;

          // Extrair a mensagem de erro da resposta
          if (err && err.error) {
            try {
              // Tentar extrair a descrição do erro
              const errorString = err.error.error;
              const match = errorString.match(/"description":"([^"]+)"/i);
              if (match && match[1]) {
                this.errorMessage = match[1];
              } else {
                this.errorMessage =
                  'Ops, parece que tivemos algum erro ao cadastrar a empresa. Verifique se todos os dados estão corretos e tente novamente';
              }
            } catch (e) {
              this.errorMessage =
                'Ops, parece que tivemos algum erro ao cadastrar a empresa. Verifique se todos os dados estão corretos e tente novamente';
            }
          } else {
            this.errorMessage =
              'Ops, parece que tivemos algum erro ao cadastrar a empresa. Verifique se todos os dados estão corretos e tente novamente';
          }
        },
      });
    }
  }

  dismissError(): void {
    this.registrationError = false;
  }
}
